import { useEffect } from 'react';

/**
 * Paint html and body to match the kiosk screen's own background.
 *
 * The shell element cannot cover the viewport on its own: below its content
 * and under the iPad's safe-area inset, whatever html/body are painted shows
 * through — which is where the beige strip along the bottom came from. The
 * ground changes between screens (paper for the customer flow, navy for the
 * confirmation), so it is set from the component rather than stated once in
 * CSS, and restored on unmount so the marketing site is not left navy.
 */
export function useKioskGround(color: string): void {
  useEffect(() => {
    const { documentElement: html, body } = document;
    const prevHtml = html.style.backgroundColor;
    const prevBody = body.style.backgroundColor;
    html.style.backgroundColor = color;
    body.style.backgroundColor = color;
    return () => {
      html.style.backgroundColor = prevHtml;
      body.style.backgroundColor = prevBody;
    };
  }, [color]);
}

/** Resolved brand tokens — the kiosk has no palette of its own. */
export const KIOSK_PAPER = '#F8F4EC';
export const KIOSK_NAVY = '#0B1B3A';
